import cn from 'classnames';
import Markdown from 'components/markdown';
import { ISectionTextFields } from 'global';
import RibbonText from 'modules/content-cms/components/ribbon-text';
import renderDocument from 'modules/content-cms/util/render-document';
import React from 'react';
import ContentContainer from '../components/content-container';
import Title from '../components/title';

const Text: React.FC<ISectionTextFields> = ({
  title,
  text,
  textAlignment,
  backgroundColor,
  disableSpacing,
  hideTitle,
  richTitle,
}) => {
  return (
    <ContentContainer
      disableSpacing={disableSpacing}
      backgroundColor={backgroundColor}
    >
      {text && (
        <Markdown
          className={cn(
            'mx-auto w-full leading-normal lg:leading-relaxed',
            textAlignment && textAlignment === 'Left' && 'text-left',
            textAlignment && textAlignment === 'Center' && 'text-center',
            textAlignment && textAlignment === 'Right' && 'text-right'
          )}
        >
          {richTitle ? (
            <RibbonText text={richTitle} />
          ) : title && hideTitle !== true ? (
            <Title>{title}</Title>
          ) : null}
          {renderDocument(text)}
        </Markdown>
      )}
    </ContentContainer>
  );
};

export default Text;
